import { render, staticRenderFns } from "./ReservationTeacherDetail.vue?vue&type=template&id=1cf50d90&scoped=true&"
import script from "./ReservationTeacherDetail.vue?vue&type=script&lang=js&"
export * from "./ReservationTeacherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf50d90",
  null
  
)

export default component.exports